import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

const StyledLessonMapItem = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  font-family: ${({ theme }) => theme.fonts.nunito};
  transition: background 0.2s;

  .lesson-item-details-container {
    display: flex;
    align-items: center;
    margin-right: 1rem;

    .lesson-item-thumbnail {
      background: ${({ theme }) => theme.colors.gray[100]};
      border-radius: 3px;
      width: 75px;
      height: 50px;
      position: relative;
      margin-right: 12px;
      flex-shrink: 0;

      img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 3px;
      }

      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        border-radius: 3px;
        box-shadow: inset 0 0 0 1px #0000001a;
      }
    }

    .lesson-item-details {
      display: grid;
      grid-gap: 4px;

      .lesson-item-title {
        font-size: 15px;
        font-weight: 600;
        letter-spacing: 0.01rem;
        color: ${({ theme }) => theme.colors.gray[700]};
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        transition: color 0.2s;
      }

      .lesson-item-time {
        font-size: 14px;
        letter-spacing: 0.01rem;
        color: ${({ theme }) => theme.colors.gray[500]};
      }
    }
  }

  .check-box {
    height: 28px;
    width: 28px;

    input {
      border-radius: 50%;
      border-color: ${({ theme }) => theme.colors.gray[500]};
      box-shadow: 0 0 0 4px ${({ theme }) => theme.colors.gray[200]};

      &:checked, &:hover, &:hover:checked:not(:disabled), &:hover:not(:checked):not(:disabled) {
        border-color: ${({ theme }) => theme.colors.green[300]};
        background-color: ${({ theme }) => theme.colors.green[300]};
        box-shadow: 0 0 0 4px ${({ theme }) => theme.colors.green[100]};
      }
    }
  }

  &.active {
    background: ${({ theme }) => theme.colors.green[50]};
  }
`

export default StyledLessonMapItem
